export default {"src":"/_next/static/media/mail.84a16afa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};